import apiClient from 'api/apiClient';

const BASE = process.env.REACT_APP_USER_REST_API_BASE_URL
  ? `${process.env.REACT_APP_USER_REST_API_BASE_URL}/api/v4/admin/templates`
  : 'http://localhost:8080/api/v4/admin/templates';

export interface SectionRecord {
  id: number;
  title: string;
  sectionType: string;
  description: string | null;
  sequenceOrder: number;
  required: boolean;
}

export interface TemplateRecord {
  id: number;
  code: string;
  name: string;
  templateType: string;
  description: string | null;
  status: 'DRAFT' | 'PUBLISHED' | 'RETIRED';
  version: number;
  sectionCount: number;
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
  sections: SectionRecord[];
}

export interface SectionRequest {
  title: string;
  sectionType: string;
  description?: string;
  sequenceOrder: number;
  required: boolean;
}

export interface TemplateRequest {
  name: string;
  templateType: string;
  description?: string;
  sections: SectionRequest[];
}

export const listTemplates = () =>
  apiClient.get<TemplateRecord[]>(BASE);

export const getTemplate = (id: number) =>
  apiClient.get<TemplateRecord>(`${BASE}/${id}`);

export const createTemplate = (req: TemplateRequest) =>
  apiClient.post<TemplateRecord>(BASE, req);

export const updateTemplate = (id: number, req: TemplateRequest) =>
  apiClient.put<TemplateRecord>(`${BASE}/${id}`, req);

export const publishTemplate = (id: number, reason: string) =>
  apiClient.post<TemplateRecord>(`${BASE}/${id}/publish`, { reason });

export const cloneTemplate = (id: number) =>
  apiClient.post<TemplateRecord>(`${BASE}/${id}/clone`);

export const retireTemplate = (id: number, reason: string) =>
  apiClient.put<TemplateRecord>(`${BASE}/${id}/retire`, { reason });
